import { IconType } from '@sato/components';

import {
  Incident,
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';

const classificationIcons = {
  [IncidentClassification.CONTRACTS]: 'agreementNormal',
  [IncidentClassification.KEYS]: 'key',
  [IncidentClassification.DEFECT_REPORT]: 'maintenance',
  [IncidentClassification.DEFECT_REPORT_PUBLIC]: 'maintenance',
  [IncidentClassification.RENTALPAYMENT_STATUS]: 'cardCoins',
  [IncidentClassification.APARTMENT_CONDITION]: 'maintenance',
  [IncidentClassification.SUPPORT]: 'message',
  [IncidentClassification.TERMINATION]: 'agreementNormal',
  [IncidentClassification.SALES]: 'agreementNormal',
  [IncidentClassification.SALES_CONTACTS]: 'agreementNormal',
  [IncidentClassification.CREATED_BY_SATO]: 'message',
  [IncidentClassification.FACILITY_RESERVATION]: 'message',
} satisfies Record<IncidentClassification, IconType>;

const subClassificationIcons: Partial<
  Record<IncidentSubClassification, IconType>
> = {
  [IncidentSubClassification.PAINTING]: 'renovation',
  [IncidentSubClassification.RENOVATE]: 'renovation',
  [IncidentSubClassification.PARKING_ISSUE]: 'car',
  [IncidentSubClassification.PARKING_SPACE_RENTING]: 'car',
  [IncidentSubClassification.DISORDER]: 'disturbance',
  [IncidentSubClassification.ORDER_NEW_KEY]: 'keyNew',
  [IncidentSubClassification.ORDER_NEW_COMMON_SPACES_KEY]: 'keyNew',
  [IncidentSubClassification.LOST_KEY]: 'keyLost',
  [IncidentSubClassification.NEW_PARTY]: 'personAdd',
  [IncidentSubClassification.NEW_RESIDENT]: 'personAdd',
  [IncidentSubClassification.SAUNA_RESERVATION]: 'saunaV2',
};

export const getIncidentIcon = ({
  classification,
  subClassification,
}: Incident) => {
  const subClassificationIcon = subClassification
    ? subClassificationIcons[subClassification]
    : undefined;

  const classificationIcon = classification
    ? classificationIcons[classification]
    : undefined;

  return subClassificationIcon ?? classificationIcon ?? 'message24';
};
